// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const patternRoutes = [
  {
    path: 'accept-rate',
    loadChildren: () =>
      import('./accept-rate/accept-rate-stories.module').then(
        m => m.AcceptRateStoriesModule,
      ),
  },
  {
    path: 'ai-button',
    loadChildren: () =>
      import('./ai-button/ai-button-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'ai-modal',
    loadChildren: () =>
      import('./ai-modal/ai-modal-stories.module').then(
        m => m.AiModalStoriesModule,
      ),
  },
  {
    path: 'ai-textarea',
    loadChildren: () =>
      import('./ai-textarea/ai-textarea-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'auto-complete',
    loadChildren: () =>
      import('./auto-complete/auto-complete-stories.module').then(
        m => m.AutoCompleteStoriesModule,
      ),
  },
  {
    path: 'auto-link',
    loadChildren: () =>
      import('./auto-link/auto-link-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'best-practises',
    loadChildren: () =>
      import('./best-practises/best-practises-stories.module').then(
        m => m.BestPractisesStoriesModule,
      ),
  },
  {
    path: 'bid-pattern-card',
    loadChildren: () =>
      import('./bid-pattern-card/bid-pattern-card-stories.module').then(
        m => m.BidPatternCardStoriesModule,
      ),
  },
  {
    path: 'challenge-status-tag',
    loadChildren: () =>
      import(
        './challenge-status-tag/challenge-status-tag-stories.routing'
      ).then(m => m.storyRoutes),
  },
  {
    path: 'chat-button',
    loadChildren: () =>
      import('./chat-button/chat-button-stories.module').then(
        m => m.ChatButtonStoriesModule,
      ),
  },
  {
    path: 'comment-ui',
    loadChildren: () =>
      import('./comment-ui/comment-ui-stories.module').then(
        m => m.CommentUiStoriesModule,
      ),
  },
  {
    path: 'completed-jobs',
    loadChildren: () =>
      import('./completed-jobs/completed-jobs-stories.module').then(
        m => m.CompletedJobsStoriesModule,
      ),
  },
  {
    path: 'directory-item',
    loadChildren: () =>
      import('./directory-item/directory-item-stories.module').then(
        m => m.DirectoryItemStoriesModule,
      ),
  },
  {
    path: 'earnings',
    loadChildren: () =>
      import('./earnings/earnings-stories.module').then(
        m => m.EarningsStoriesModule,
      ),
  },
  {
    path: 'experience',
    loadChildren: () =>
      import('./experience/experience-stories.module').then(
        m => m.ExperienceStoriesModule,
      ),
  },
  {
    path: 'image-caption',
    loadChildren: () =>
      import('./image-caption/image-caption-stories.module').then(
        m => m.ImageCaptionStoriesModule,
      ),
  },
  {
    path: 'interactive-text',
    loadChildren: () =>
      import('./interactive-text/interactive-text-stories.module').then(
        m => m.InteractiveTextStoriesModule,
      ),
  },
  {
    path: 'linkshim',
    loadChildren: () =>
      import('./linkshim/linkshim-stories.module').then(
        m => m.LinkshimStoriesModule,
      ),
  },
  {
    path: 'newsfeed-system-messages',
    loadChildren: () =>
      import(
        './newsfeed-system-messages/newsfeed-system-messages-stories.module'
      ).then(m => m.NewsfeedSystemMessagesStoriesModule),
  },
  {
    path: 'project-contest-card',
    loadChildren: () =>
      import('./project-contest-card/project-contest-card-stories.module').then(
        m => m.ProjectContestCardStoriesModule,
      ),
  },
  {
    path: 'radio-card',
    loadChildren: () =>
      import('./radio-card/radio-card-stories.module').then(
        m => m.RadioCardStoriesModule,
      ),
  },
  {
    path: 'review-card',
    loadChildren: () =>
      import('./review-card/review-card-stories.module').then(
        m => m.ReviewCardStoriesModule,
      ),
  },
  {
    path: 'review-count',
    loadChildren: () =>
      import('./review-count/review-count-stories.module').then(
        m => m.ReviewCountStoriesModule,
      ),
  },
  {
    path: 'section-article',
    loadChildren: () =>
      import('./section-article/section-article-stories.module').then(
        m => m.SectionArticleStoriesModule,
      ),
  },
  {
    path: 'section-case-study-carousel',
    loadChildren: () =>
      import(
        './section-case-study-carousel/section-case-study-carousel-stories.module'
      ).then(m => m.SectionCaseStudyCarouselStoriesModule),
  },
  {
    path: 'section-companies',
    loadChildren: () =>
      import('./section-companies/section-companies-stories.module').then(
        m => m.SectionCompaniesStoriesModule,
      ),
  },
  {
    path: 'section-feature',
    loadChildren: () =>
      import('./section-feature/section-feature-stories.module').then(
        m => m.SectionFeatureStoriesModule,
      ),
  },
  {
    path: 'section-gallery',
    loadChildren: () =>
      import('./section-gallery/section-gallery-stories.module').then(
        m => m.SectionGalleryStoriesModule,
      ),
  },
  {
    path: 'section-hero',
    loadChildren: () =>
      import('./section-hero/section-hero-stories.module').then(
        m => m.SectionHeroStoriesModule,
      ),
  },
  {
    path: 'service-offering-carousel',
    loadChildren: () =>
      import(
        './service-offering-carousel/service-offering-carousel-stories.module'
      ).then(m => m.ServiceOfferingCarouselStoriesModule),
  },
  {
    path: 'share-modal',
    loadChildren: () =>
      import('./share-modal/share-modal-stories.module').then(
        m => m.ShareModalStoriesModule,
      ),
  },
  {
    path: 'showcase-card',
    loadChildren: () =>
      import('./showcase-card/showcase-card-stories.module').then(
        m => m.ShowcaseCardStoriesModule,
      ),
  },
  {
    path: 'skills',
    loadChildren: () =>
      import('./skills/skills-stories.module').then(m => m.SkillsStoriesModule),
  },
  {
    path: 'upgrade-item',
    loadChildren: () =>
      import('./upgrade-item/upgrade-item-stories.module').then(
        m => m.UpgradeItemStoriesModule,
      ),
  },
  {
    path: 'upgrade-tag',
    loadChildren: () =>
      import('./upgrade-tag/upgrade-tag-stories.module').then(
        m => m.UpgradeTagStoriesModule,
      ),
  },
  {
    path: 'user-feedback',
    loadChildren: () =>
      import('./user-feedback/user-feedback-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'user-info',
    loadChildren: () =>
      import('./user-info/user-info-stories.module').then(
        m => m.UserInfoStoriesModule,
      ),
  },
  {
    path: 'user-rehire-card',
    loadChildren: () =>
      import('./user-rehire-card/user-rehire-card-stories.module').then(
        m => m.UserRehireCardStoriesModule,
      ),
  },
  {
    path: 'user-search-card',
    loadChildren: () =>
      import('./user-search-card/user-search-card-stories.module').then(
        m => m.UserSearchCardStoriesModule,
      ),
  },
  {
    path: 'username',
    loadChildren: () =>
      import('./username/username-stories.module').then(
        m => m.UsernameStoriesModule,
      ),
  },
  {
    path: 'video-record-input',
    loadChildren: () =>
      import('./video-record-input/video-record-input-stories.module').then(
        m => m.VideoRecordInputStoriesModule,
      ),
  },
  {
    path: 'video-record-modal',
    loadChildren: () =>
      import('./video-record-modal/video-record-modal-stories.module').then(
        m => m.VideoRecordModalStoriesModule,
      ),
  },
  {
    path: 'worked-time',
    loadChildren: () =>
      import('./worked-time/worked-time-stories.module').then(
        m => m.WorkedTimeStoriesModule,
      ),
  },
];
